<template>
  <div class="border-right">
      <inbound-upload-modal></inbound-upload-modal>
      <div class="btn-container bg-cx3 p-2 d-flex justify-content-between">
        <router-link class="btn btn-sm btn-outline-light border-0" to="/inbound/new">
          <i class="far fa-edit"></i> New
        </router-link>
        <button class="btn btn-sm btn-outline-light border-0" @click="openUploadModal">
          <i class="fa fa-upload"></i> Upload
        </button>
        <button class="btn btn-sm btn-outline-light border-0" @click="refresh">
          <i class="fa fa-sync-alt" :class="{'fa-spin': loading}"></i>
        </button>        
      </div>
      <div class="list-group">
        <template v-for="status in statuses" >
          <router-link :to="'/inbound/' + status.slug" 
            v-if="!status.hide"
            :key="status.id"
            class="list-group-item list-group-item-action d-flex flex-row justify-content-between border-0"
            :class="{ active: status.active }"
          > 
            <span>
              <i class="far fa-folder mr-2" :class="{'fa-folder-open': status.active}"></i>
              {{ status.name }}
            </span>
            <span v-if="status.ct && status.id != 15" class="badge badge-light">{{ status.ct }}</span>
          </router-link>
        </template>
      </div>
  </div>
</template>

<script>
import $ from 'jquery'
import InboundUploadModal from '@/components/inbound/UploadModal.vue'
import api from '@/api'
import store from '@/stores/inbound'

export default {
  name: 'status-menu',

  props: ['statuses'],

  data() {
    return {
      loading: false
    }
  },

  components: {
    InboundUploadModal,
  },

  methods: {
    refresh() {
      this.loading = true
      api.get('/inbound-orders').then(res => {
        store.setOrders(res.data.orders)
        this.loading = false
      })
    },

    newOrder() {
      alert('Not yet, but soon.')
    },
    
    openUploadModal() {
      $('#inboundUploadModal').modal('show')
    }
  }
}
</script>

<style scoped>
  .badge {
    padding: 5px;
  }
  .list-group {
    height: calc(100vh - 48px);
    background: none;
    opacity: .8;
  }

  .list-group-item {
    color: #efefef;
    background: transparent;
    padding: 0.5rem 1rem;
    border:0;
  }

  .list-group-item-action:hover {
    background-color: rgb(53, 73, 104);
    color: ##fff;
  }

  .list-group-item.active {
    background: rgb(53, 73, 104);
    border: 0;
  }
  .btn-container {
    margin-top: 0px;
    opacity: .8;
    border-bottom:1px solid rgb(53, 73, 104);
  }
</style>